import { render } from "./defaultLayout.vue?vue&type=template&id=6bbb3988&scoped=true"
import script from "./defaultLayout.vue?vue&type=script&lang=js"
export * from "./defaultLayout.vue?vue&type=script&lang=js"

import "./defaultLayout.vue?vue&type=style&index=0&id=6bbb3988&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bbb3988"]])

export default __exports__